import ArchiveLayout from '@/layouts/ArchiveLayout';
import { LEGISLATION_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Legislation & Regulations',
  el: 'Νομοθεσία & Κανονισμοί',
};

const description: Record<Locale, string> = {
  en: 'Important legislation, regulations, and legal frameworks.',
  el: 'Σημαντική νομοθεσία, κανονισμοί και νομικά πλαίσια.',
};

const eyebrow: Record<Locale, string> = {
  en: 'LEGISLATION',
  el: 'ΝΟΜΟΘΕΣΙΑ',
};

const emptyState: Record<Locale, string> = {
  en: 'No legislation entries available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμες νομοθετικές καταχωρήσεις αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function LegislationArchive() {
  return (
    <ArchiveLayout
      pageKey="legislation"
      postType="legislation"
      query={LEGISLATION_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
